module.exports = __webpack_public_path__ + "static/brandlogo-5ef5c4fd60ded12ec5d547d731e807d3.png";